export default {
  BY_OBJECTS: 'browse',
  BY_CATALOG: 'catalog',
  BY_COORDINATE: 'coordinate',
  NONE: 'NONE',
  DEFAULT_FORM: 'browse',
};
